import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=6bfc8338&scoped=true&"
import script from "./Error403.vue?vue&type=script&lang=js&"
export * from "./Error403.vue?vue&type=script&lang=js&"
import style0 from "./Error403.vue?vue&type=style&index=0&id=6bfc8338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc8338",
  null
  
)

export default component.exports